module.exports = __webpack_public_path__ + "b90a354bfa5a565c13bc0443d3d8cbfd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-15.png
// module id = 2074
// module chunks = 0